export const PERMISSION = `
query ListPermissions {
  listPermissions {
    permissionKey
    isPermissionOn
  }
}
`;
